import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=13832406&scoped=true&"
import script from "./spec.vue?vue&type=script&lang=js&"
export * from "./spec.vue?vue&type=script&lang=js&"
import style0 from "./spec.vue?vue&type=style&index=0&id=13832406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13832406",
  null
  
)

export default component.exports